import textBodyM from '@fukku/styles/texts/textBodyM.module.css'
import { cx } from 'classix'
import type { ReactNode } from 'react'

import { TEST_IDS } from '../../constants/testIds'
import type { CreateComponentsConfig } from '../../types'

import styles from '../GenericStyles.module.css'

interface UnderlineProps {
	readonly children: ReactNode
	readonly customProps?: CreateComponentsConfig['underlineProps']
}

export const Underline = ({ children, customProps }: UnderlineProps) => {
	const extraProps = {
		className: cx(
			textBodyM.className,
			styles.underline,
			customProps?.className
		),
		...customProps,
	}
	return (
		<span data-testid={TEST_IDS.UNDERLINE} {...extraProps}>
			{children}
		</span>
	)
}
